<template>
  <Drawer id="printDiv" width="550" :title="`生产订单`" v-model="drawerOpened">
    <div class="drawer-content">
      <div class="print-content" ref="orederContent" id="printContent">
        <div class="drawer-info">
          <div style="display: flex;justify-content: space-between">
            <h2 class="sales">{{ openedOrder?.sales?.abbr }}</h2>
            <h2>总量：{{ openedOrder.volPlan }}吨</h2>
          </div>
          <div class="customer">
            {{ openedOrder?.customer?.name }}  {{ openedOrder?.material?.model }}-{{ openedOrder?.material?.name }}
          </div>
          <div class="material">
            订单编号：{{ openedOrder?._id }}
          </div>
          <div style="display: flex;justify-content: space-between">
            <div>
              配方：#{{ openedOrder?.recipe?.NoId }} {{ openedOrder?.recipe?.name }}
            </div>
            <div>需求时间：{{ openedOrder.planArrivedAt }}</div>
          </div>
        </div>
        <div class="drawer-tabel">
          <div class="table-wrap" ref="tableWrapper">
            <Table
              :columns="recipeColumns"
              :data="displayRecipeDetail"
              border
              show-summary
              :summary-method="handleSummary"
              :span-method="handleSpan"
            ></Table>
          </div>
        </div>
      </div>
      <div class="print-order">
        <Button
          long
          type="primary"
          ghost
          v-print="printObj"
          style="margin-right: 15px"
          >打印订单</Button
        >
        <Button long type="success" ghost @click="printOrder">下载订单</Button>
      </div>
      <SalesProdProgress
        ref="SalesProdProgress"
        :selectedRecipeDetail="selectedRecipeDetail"
        :currentSalesOrder="openedOrder"
      />
    </div>
  </Drawer>
</template>

<script>
import dayjs from "dayjs";
import html2canvas from "html2canvas";
import SalesProdProgress from "./SalesProdProgress.vue";
import jsPDF from "jspdf";
import { mapState, mapActions, mapGetters } from "vuex";
import Big from 'big.js';

const typeToText = {
  semi: "母液",
  raw: "小料",
  water: "水",
};
export default {
  name: "PrintOrderDrawer",
  props: ["selectedRecipeDetail"],
  components: { SalesProdProgress },
  computed: {
    displayRecipeDetail: function () {
      const recipeWithAmount = [];
      let totalAmountBesidesWater = 0;
      for (const item of this.recipeDetail) {
        let touLiaoAmount = 0;
        if (item.material.type === 'raw') {
          touLiaoAmount = this.openedOrder.volPlan * item.ratio * 1000;
        } else if (item.material.type === 'semi') {
          touLiaoAmount = (new Big(this.openedOrder.volPlan)).times(item.ratio).times(100).div(item.material.solidContent).times(1000).toNumber();
          // touLiaoAmount = this.openedOrder.volPlan * item.ratio / (item.material.solidContent / 100) * 1000;
        } else if (item.material.type !== 'water') {
          console.log('这个type有问题');
          console.log(item);
        }
        totalAmountBesidesWater += touLiaoAmount;
        recipeWithAmount.push({ ...item, touLiaoAmount })
      }
      const waterIndex = recipeWithAmount.findIndex(v => v.material.type === 'water');
      if (waterIndex !== -1) {
        recipeWithAmount[waterIndex].touLiaoAmount = this.openedOrder.volPlan * 1000 - totalAmountBesidesWater;
      }
      return recipeWithAmount;
    },
  },
  data() {
    return {
      printObj: {
        id: "printContent",
        popTitle: dayjs().format('YYYY/M/D'),
      },
      drawerOpened: false,
      openedOrder: {},
      recipeDetail: [],
      recipeColumns: [
        {
          title: "类型",
          key: "type",
          width: 80,
          align: "center",
          render: (h, params) =>
            h("span", typeToText[params.row.material.type]),
        },
        {
          title: "行",
          key: "row",
          width: 70,
          align: "center",
          render: (h, params) =>
            h("span", { style: { color: "darkgray" } }, params.index + 1),
        },
        {
          title: "材料",
          key: "material",
          minWidth: 100,
          render: (h, params) => {
            if (params.row.material.type === "semi")
              return h("span", params.row.material.model);
            return h("span", params.row.material.name);
          },
        },
        {
          title: "比例(%)",
          key: "ratio",
          align: "right",
          width: 80,
          render: (h, params) =>
            h("span", Number(params.row.ratio * 100).toFixed(2) + "%"),
        },
        {
          title: "固含量",
          key: "ratio",
          align: "right",
          width: 60,
          render: (h, params) =>
            h(
              "span",
              params.row.material.solidContent
                ? Number(params.row.material.solidContent).toFixed(1) + "%"
                : ""
            ),
        },
        {
          title: "实际投料(kg)",
          key: "actualDosage",
          align: "right",
          width: 100,
          render: (h, params) =>
            h("span", params.row.touLiaoAmount.toFixed(2)),
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      getRecipeSalesWithMaterialDetail: "recipeSales/getRecipeSalesWithMaterialDetailAction",
    }),
    async openDrawer(order) {
      this.openedOrder = order; 
      this.drawerOpened = true;

      try {
        const { recipeSales, error } = await this.getRecipeSalesWithMaterialDetail({
          id: order.recipe._id,
          data: {
            factory: order.factory._id,
          },
        });
        this.recipeDetail = recipeSales.detail;
      } catch (error) {
        this.$Message.error('载入配方错误！！')
      }
      
    },
    // 计算合计
    handleSummary({ columns, data }) {
      const sums = {};
      columns.forEach((column, index) => {
        const key = column.key;
        switch (index) {
          case 0:
            sums[key] = {
              key,
              value: "合计",
            };
            return;
          case 1:
            sums[key] = {
              key,
              value: "",
            };
            return;
          case 2:
            sums[key] = {
              key,
              value: "",
            };
            return;
          case 3:
            const values = data.map((item) => Number(item.ratio));
            if (values && !values.every((value) => isNaN(value))) {
              const v = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
              sums[key] = {
                key,
                value: v * 100 + "%",
              };
            }
            return;
          case 4:
            sums[key] = {
              key,
              value: "",
            };
            return;
          case 5:
            sums[key] = {
              key,
              value: this.openedOrder.volPlan * 1000,
            };
            return;
          default:
            break;
        }
      });
      return sums;
    },
    // 计算合并
    handleSpan({ row, column, rowIndex, columnIndex }) {
      // 将母液和小料取出
      let typeList = this.recipeDetail.map((item) => {
        return item.material.type;
      });
      // 计算母液和小料的数量
      let semiNum = 0;
      let rawNum = 0;
      typeList.forEach((x) => {
        if (x === "semi") {
          semiNum++;
        } else if (x === "raw") {
          rawNum++;
        }
      });
      // 对表格进行同类型合并
      if (semiNum === 0) {
        semiNum = rawNum;
      }
      if (rowIndex === 0 && columnIndex === 0) {
        // 母液合并
        return {
          rowspan: semiNum,
          colspan: 1,
        };
      } else if (rowIndex > 0 && rowIndex < semiNum && columnIndex === 0) {
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
      if (rawNum === 0) {
        return;
      } else {
        if (rowIndex === semiNum && columnIndex === 0) {
          // 小料合并
          return {
            rowspan: rawNum,
            colspan: 1,
          };
        } else if (
          rowIndex > semiNum &&
          rowIndex < typeList.length - 1 &&
          columnIndex === 0
        ) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    getRepeatNum(list) {
      return list.reduce((prev, next) => {
        prev[next] = prev[next] + 1 || 1;
        return prev;
      }, {});
    },
    // 打印订单
    printOrder() {
      html2canvas(this.$refs.orederContent, {
        scale: 2, // 按两倍缩放
      }).then(async function (canvas) {
        // 将图片转化为dataUrl
        let pageData = canvas.toDataURL("image/jpeg", 1.0);

        let imgWidth = 595.28;
        let imgHeight = (595.28 / canvas.width) * canvas.height;

        let orderPdf = new jsPDF("p", "pt", "a4");

        orderPdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);

        const pdfDo = await orderPdf.save(
          `生产订单${dayjs().format("YYYY-MM-DD HH:mm")}.pdf`
        );
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.print-order
  margin 10px 0
  display flex

@media print
  #printContent
    aspect-ratio auto 5 / 3
    width 550px

  .title
    // font-size 12px
</style>